/* eslint-disable camelcase */
/* eslint-disable eqeqeq */
import api from '../../services/service_item'
import api_ser from '../../services/service'
import Swal from 'sweetalert2'
export default {
  data () {
    return {
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      modal_active: false,
      id_receive: null,
      tmp_data: {
        'barcode': '',
        'rate_1': 1,
        'unit_code': '',
        'is_default': 0,
        'price_1': 0,
        'price_2': 0,
        'price_3': 0,
        'price_4': 0,
        'price_5': 0,
        'price_6': 0,
        'price_active': 1
      },
      previewVisible: false,
      previewImage: '',
      temp_code: 'xxxxxxxx',
      item_detail: {
        'id': 0,
        'code': '',
        'name': '',
        'short_name': '',
        'name_en': '',
        'name_cn': '',
        'stk_unit_code': '',
        'stock_type': 0,
        'menu_id': 0,
        'menu_seq': 0,
        'depart_code': '',
        'color_code': '',
        'item_type': '',
        'category_code': '',
        'image_1': '',
        'group_code': '',
        'description': '',
        'stock_min': 1,
        'stock_qty': 0,
        'weight': 1,
        'is_return': 0,
        'is_expired': 0,
        'create_by': '',
        'edit_by': '',
        'active_status': false,
        'bar_data': [],
        'is_vat': false
      },
      fileList: [
        // {
        //   uid: '-1',
        //   name: 'xxx.png',
        //   status: 'done',
        //   url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png'
        // }
      ],
      confirmDirty: false,
      autoCompleteResult: [],
      formItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 }
      },
      tailFormItemLayout: {
        wrapperCol: {
          span: 16,
          offset: 8
        }
      },
      unit: [],
      catagory: [],
      group: [],
      department: [],
      item_type: [],
      item: null,
      item_color: [
        { 'code': 'green', 'name': 'เขียว' },
        { 'code': 'yellow', 'name': 'เหลือง' },
        { 'code': 'orange', 'name': 'ส้ม' },
        { 'code': 'blue', 'name': 'น้ำเงิน' },
        { 'code': 'gray', 'name': 'เทา' }
      ],
      branch: null
    }
  },
  methods: {
    status_is_process (val) {
      switch (val) {
        case 1:
          return 'กำลังคำนวน'
        case 0:
          return 'สำเร็จ'
        default:
          return 'ไม่พบสถานะ'
      }
    },
    onUnitSelect (val) {
      let mock_data = {
        'barcode': '',
        'rate_1': 1,
        'unit_code': val,
        'is_default': 1,
        'price_1': 0,
        'price_2': 0,
        'price_3': 0,
        'price_4': 0,
        'price_5': 0,
        'price_6': 0,
        'price_active': 1
      }
      this.item_detail.bar_data[0] = mock_data
    },
    onChange (checked) {
      if (checked == false) {
        this.item_detail.active_status = false
      }
      if (checked == true) {
        this.item_detail.active_status = true
      }
    },
    onChangeVat (checked) {
      // console.log(checked)
      if (checked == false) {
        this.item_detail.is_vat = false
      }
      if (checked == true) {
        this.item_detail.is_vat = true
      }
    },
    handleCancel () {
      this.previewVisible = false
    },
    handlePreview (file) {
      this.previewImage = file.url || file.thumbUrl
      this.previewVisible = true
    },
    handleChange ({ fileList }) {
      this.fileList = fileList
    },
    getUnit () {
      api.itemUnit(this.branch.dyn_address + '/',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        }, {},
        result => {
          if (result.response === 'success') {
            this.unit = result.data
          } else {
            this.alert_msg('warning', 'ดึงข้อมูลหน่วยนับไม่ได้', result.message)
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getGroup () {
      api.itemGroup(this.branch.dyn_address + '/',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        {},
        result => {
          if (result.response === 'success') {
            this.group = result.data
          } else {
            this.alert_msg('warning', 'ดึงข้อมูลกลุ่มสินค้าไม่ได้', result.message)
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    itemCatagory () {
      api.itemCatagory(this.branch.dyn_address + '/',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        {},
        result => {
          if (result.response === 'success') {
            this.catagory = result.data
          } else {
            this.alert_msg('warning', 'ดึงข้อมูลหมวดหมู่ไม่ได้', result.message)
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    itemDepartment () {
      api.itemDepartment(this.branch.dyn_address + '/',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        {},
        result => {
          if (result.response === 'success') {
            this.department = result.data
          } else {
            this.alert_msg('warning', 'ดึงข้อมูลแผนกไม่ได้', result.message)
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    getItem () {
      this.$store.commit('Loading')
      api.itemById(this.branch.dyn_address + '/',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        { 'id': parseInt(this.id_receive) },
        result => {
          this.$store.commit('Loading')
          if (result.response === 'success') {
            this.item_detail = result.data
            if (this.item_detail.active_status == 0) {
              this.item_detail.active_status = false
            }
            if (this.item_detail.active_status == 1) {
              this.item_detail.active_status = true
            }
            if (this.item_detail.is_vat == 0) {
              this.item_detail.is_vat = false
            }
            if (this.item_detail.is_vat == 1) {
              this.item_detail.is_vat = true
            }
          } else {
            this.alert_msg('warning', 'ดึงข้อมูลหน่วยนับไม่ได้', result.message)
          }
        },
        error => {
          this.$store.state.isLoading = false
          alert('ไม่สามารถเข้าถึงข้อมูลสินค้า ' + JSON.stringify(error))
        }
      )
    },
    itemType () {
      this.code = '1001'
      api.itemType(this.branch.dyn_address + '/',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        { 'barcode': this.code },
        result => {
          if (result.response === 'success') {
            this.item_type = result.data
          } else {
            this.alert_msg('warning', 'ดึงข้อมูลหน่วยนับไม่ได้', result.message)
          }
        },
        error => {
          this.$store.state.isLoading = false
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    confirmData () {
      // for (let i = 0; i < this.item_detail.bar_data.length; i++) {
      //   this.item_detail.bar_data[i].price_1 = parseFloat(this.item_detail.bar_data[i].price_1)
      //   this.item_detail.bar_data[i].price_2 = parseFloat(this.item_detail.bar_data[i].price_2)
      //   this.item_detail.bar_data[i].price_3 = parseFloat(this.item_detail.bar_data[i].price_3)
      //   this.item_detail.bar_data[i].price_4 = parseFloat(this.item_detail.bar_data[i].price_4)
      //   this.item_detail.bar_data[i].price_5 = parseFloat(this.item_detail.bar_data[i].price_5)
      //   this.item_detail.bar_data[i].price_6 = parseFloat(this.item_detail.bar_data[i].price_6)
      // }
      // console.log(JSON.stringify(this.item_detail))
      this.addItem()
    },
    close_modal () {
      this.modal_active = false
      this.tmp_data = {
        'barcode': '',
        'rate_1': 1,
        'unit_code': '',
        'is_default': 0,
        'price_1': 0,
        'price_2': 0,
        'price_3': 0,
        'price_4': 0,
        'price_5': 0,
        'price_6': 0,
        'price_active': 1
      }
    },
    add_subitem () {
      var index = this.item_detail.bar_data.findIndex(x => x.barcode === this.tmp_data.barcode)
      if (index < 0) {
        this.item_detail.bar_data.push(this.tmp_data)
        this.close_modal()
      } else {
        this.item_detail.bar_data[index] = this.tmp_data
        this.close_modal()
      }
    },
    reDataSubitem (val) {
      console.log(val)
      for (let index = 0; index < this.item_detail.bar_data.length; index++) {
        if (val != index) {
          this.item_detail.bar_data[index].is_default = 0
        }
      }
    },
    addItem () {
      if (this.item_detail.active_status == false) {
        this.item_detail.active_status = 0
      }
      if (this.item_detail.active_status == true) {
        this.item_detail.active_status = 1
      }
      if (this.item_detail.is_vat == false) {
        this.item_detail.is_vat = 0
      }
      if (this.item_detail.is_vat == true) {
        this.item_detail.is_vat = 1
      }
      api.itemAdd(this.branch.dyn_address + '/',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        this.item_detail,
        result => {
          if (result.response === 'success') {
            this.alert_msg('success', 'แก้ไขข้อมูลผู้ใช้งานสำเร็จ', result.message)
            this.$router.push('/itemlist')
          } else {
            console.log(result)
            this.alert_msg('warning', 'ดึงข้อมูลหน่วยนับไม่ได้', result)
          }
        },
        error => {
          console.log(error)
          this.$store.state.isLoading = false
          this.alert_msg('error', 'ข้อมูลไม่ถูกต้อง', error.data.error)
          // alert('ไม่สามารถเข้าถึงข้อมูล ' + error)
        }
      )
    },
    remove_sub (index) {
      console.log(index)
      this.item_detail.bar_data.splice(index, 1)
    },
    uploadImgDefault () {
      var imagefile = document.querySelector('#imgDefault')
      if (imagefile.files.length > 0) {
        let formData = new FormData()
        formData.append('myFile', imagefile.files[0])
        formData.append('type', 'product')
        api_ser.uploadImage(
          this.branch.dyn_address + '/',
          {
            headers: {
              'Access-Token': this.branch.access_token
            }
          },
          formData,
          result => {
            if (result.response === 'success') {
              this.item_detail.image_1 = result.data.url
            } else {
              alert(result.message)
            }
          },
          error => {
            this.$store.state.isLoading = false
            alert(JSON.stringify(error))
          }
        )
      }
    },
    recalProcessStock () {
      this.$store.commit('Loading')
      let payload = {
        'item_code': this.item_detail.code
      }
      api.recalStock(
        this.branch.dyn_address + '/',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        payload,
        result => {
          this.$store.commit('Loading')
          if (result.response === 'success') {
            Swal.fire({
              icon: 'success',
              title: 'กำลังทำการคำนวนสต๊อกใหม่',
              showConfirmButton: false,
              timer: 5000
            })
          } else {
            alert(result.message)
          }
        },
        error => {
          this.$store.commit('Loading')
          alert(JSON.stringify(error))
        }
      )
    }
  },
  created () {
    this.getBranch()
    this.id_receive = this.$route.params.id
    setTimeout(() => {
      this.$store.state.branch_list.forEach(v => {
        if (parseInt(this.$route.params.branch_id) === parseInt(v['id'])) {
          this.branch = v
        }
      })
      setTimeout(() => {
        this.getUnit()
        this.getGroup()
        this.itemCatagory()
        this.itemType()
        this.itemDepartment()
      }, 1500)
    }, 1000)
  },
  mounted () {
    setTimeout(() => {
      if (this.id_receive != null && this.id_receive != 0) {
        this.getItem()
      }
    }, 2000)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/manage_item.js